
import { logException } from '@/utils/log'
import { debounce } from 'lodash'
import Vue from 'vue'

export default Vue.extend({
  props: {
    searchInput: { type: String, required: false },
    callback: Function,
    args: { type: Array, default: () => [] },
    delay: { type: Number, default: 500 },
    selected: {},
    value: {},
    returnObject: {
      type: Boolean,
      default: false,
    },
    noCache: {
      type: Boolean,
      default: false,
    },
    initQuery: { // lance la requête dès son apparaition
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      debounced: debounce((callback: (arg: unknown) => void, value: unknown) => { callback(value) }, this.delay),
      loading: false,
      items: [] as unknown[],
    }
  },
  methods: {
    input(value: unknown) {
      this.$emit('input', value)
    },
    query(value: unknown) {
      if (value !== undefined && value !== null) {
        this.loading = true
        this.debounced(this.afterQuery, value)
      }
    },
    async afterQuery(value: unknown) {
      try {
        this.items = await this.callback(value, ...this.args)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        logException(`le callback ${this.callback.name} a rencontré un problème`)
        logException(e)
        this.items = []
      }
      this.loading = false
    },
  },
  mounted() {
    if (this.initQuery) {
      this.loading = true
      this.afterQuery(undefined)
    }
  },
  watch: {
    searchInput: {
      handler(val, old) {
        if (val === undefined && old === undefined && this.value != null) {
          return
        }
        if (val !== old || old === undefined) {
          this.afterQuery(val)
        }
      },
      immediate: true,
    },
    value: {
      immediate: true,
      handler(val, oldVal) {
        if (val != null && oldVal === undefined && this.returnObject) {
          this.items = [val]
        }
      },
    },
    selected: {
      immediate: true,
      handler(val) {
        if (val != null) {
          this.items = [val]
        }
      },
    },
  },
})
